// extracted by mini-css-extract-plugin
export var card = "_ay-0";
export var expandedCard = "_ay-2";
export var paginated = "_ay-1";